import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  offerSearchList: [],
  loading: false,
  error: null,
};

const GetAllOfferSearchSlice = createSlice({
  name: "GetAllOfferSearch",
  initialState,
  reducers: {
    fetchOfferSearchStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchOfferSearchSuccess: (state, action) => {
      state.loading = false;
      state.offerSearchList = action.payload;
    },

    fetchOfferSearchFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchOfferSearchStart,
  fetchOfferSearchSuccess,
  fetchOfferSearchFailure,
} = GetAllOfferSearchSlice.actions;

export default GetAllOfferSearchSlice.reducer;